import type { OnboardingStatus } from '@onefootprint/request-types';
import type { EntityStatus } from '@onefootprint/request-types/dashboard';

type Status = 'success' | 'error' | 'warning' | 'neutral';

const statusToVariant: Record<OnboardingStatus | EntityStatus, Status> = {
  pass: 'success',
  fail: 'error',
  incomplete: 'warning',
  in_progress: 'warning',
  pending: 'warning',
  error: 'error',
  none: 'neutral',
};

const getBadgeVariantByStatus = (status: OnboardingStatus | EntityStatus, requiresManualReview?: boolean): Status => {
  if (status === 'pass' && requiresManualReview) {
    return 'warning';
  }
  return statusToVariant[status];
};

export default getBadgeVariantByStatus;
